import React from 'react';

import { Card, Typography } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import { items } from './content';
import type { IHelpersItem } from './content';

const iconMap: Record<IHelpersItem['icon'], typeof Icon.Flag> = {
  flag: Icon.Flag,
  book: Icon.BookOpen,
  help: Icon.CircleHelp,
  language: Icon.Globe
};

const Actions = () => {
  return (
    <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4'>
      {items.map(({ id, link, icon, title, description }) => {
        const ActionIcon = iconMap[icon];

        return (
          <Typography.Link
            key={id}
            href={link}
            target='_blank'
            rel='noopener noreferrer'
            className='group block h-full text-inherit no-underline hover:text-inherit hover:no-underline'
          >
            <Card
              className='h-full rounded-(--uizz-antd-border-radius-lg) transition-[background-color,border-color] duration-200 group-hover:border-(--uizz-antd-color-primary) group-hover:bg-(--uizz-antd-color-primary-bg)'
              classNames={{ body: 'p-(--uizz-antd-padding-lg)' }}
            >
              <div className='flex flex-col items-center gap-2 text-center'>
                <ActionIcon size={28} className='text-(--uizz-antd-color-primary)' />
                <Typography.Text strong>{title}</Typography.Text>
                <Typography.Text type='secondary'>{description}</Typography.Text>
              </div>
            </Card>
          </Typography.Link>
        );
      })}
    </div>
  );
};

export default Actions;
